import React, { useState, useCallback, useEffect, useMemo, useRef } from "react";

import {
  Card,
  CardBody,
  Col,
  Collapse,
  Nav,
  NavItem,
  NavLink,
  Row,
  TabContent,
  TabPane,
  Spinner,
} from "reactstrap";
// custom component

import PerfectScrollbar from "react-perfect-scrollbar";

import FormsData from "./subcomponents/FormsData/index";

import Clock from "./subcomponents/Clock";

import classnames from "classnames";

import OtherOptionsButton from "../../components/common/OtherOptionsButton";

//i18n
import { withTranslation } from "react-i18next";
import { useTranslation } from "react-i18next";

//Redux
import { useSelector, useDispatch } from "react-redux";
import { getConsumerTickets } from "../../../../store/consumerTickets/actions";

import HorizontalTimeline from "./subcomponents/ProcessData/HorizontalTimeline";
import VerticalTimeline from "./subcomponents/ProcessData/VerticalTimeline";


import Interaction from "./subcomponents/Interaction";

// Theme style
import "./lightTheme.scss";

import ConsumerTickets from "./subcomponents/ConsumerTickets";
import { useSlaTimeInExceptionOrOutsideOpeningHours } from "../../hooks/useTimeInExceptionOrOutsideOpeningHours";
import { findLast } from "../../../../Libs/CustomMethods/customMethods";
import { handleTimer, isValidMsg } from "../../functions/utils";
import { handleSLA, handleTime } from "../../functions/chat";
import { useStateWithIntervalUpdate } from "../../hooks/useStateWithIntervalUpdate";
import moment from "moment";
import { getConsumerConversations } from "../../../../store/operator/actions";

const importDarkMode = (mainTheme) => {
  if (mainTheme === "dark") {
    require("./darkTheme.scss");
  }
};

const TicketChat = (props) => {
  const { mainTheme } = useSelector((state) => state.Layout);
  importDarkMode(mainTheme);
  const dispatch = useDispatch();

  const { messageConsumer } = useSelector(
    (state) => state.Operator
  );

  const consumerTicketsData = useSelector(
    (state) =>
      state.ConsumerTickets.data?.[
      props?.conversation?.conversation?.consumer?.id
      ]
  );

  const consumerTicketsStatus = useSelector(
    (state) =>
      state.ConsumerTickets.status?.[
      props?.conversation?.conversation?.consumer?.id
      ]
  );

  let historyChats =
    messageConsumer && messageConsumer.chats && messageConsumer.chats.data;
  historyChats =
    historyChats?.[props?.conversation?.conversation?.consumer?.id];
  let loading2 = (
    <div className="w-100 pb-3 text-center">
      <Spinner
        animation="border"
        size="sm"
        className="spinner my-2 smallSpinner"
      />
    </div>
  );

  const [customActiveTab, setCustomActiveTab] = useState("1");
  const [collapse, setCollapse] = useState([]);
  const [openTicketsContent, setOpenTicketsContent] = useState(false);
  const [interactionsChatId, setInteractionsChatId] = useState(
    props?.conversation?.conversation?.conversationId
  );
  const { t } = useTranslation();

  useEffect(() => {
    setInteractionsChatId(props?.conversation?.conversation?.conversationId);
  }, [props?.conversation?.conversation?.conversationId]);

  function handleRefresh() {
    dispatch(
      getConsumerTickets(props?.conversation?.conversation?.consumer?.id)
    );
  }

  useEffect(() => {
    if(
      customActiveTab === "2" && messageConsumer && !messageConsumer?.chats?.data[props?.conversation?.conversation?.consumer?.id]
    ) {
      dispatch(getConsumerConversations(conversation?.consumer?.id, conversation.channel))
    }
    if (consumerTicketsData) return;
    handleRefresh();
  }, [props?.conversation?.conversation?.consumer?.id]);

  const { conversation: { conversation } } = props

  const slaTime = useSlaTimeInExceptionOrOutsideOpeningHours(conversation, 1000)

  const timePausedInSla = useMemo(() => {
    const timeInException = conversation.slaCount?.exceptionsSlaSeconds ?? 0
    return timeInException + slaTime
  }, [conversation.slaCount?.exceptionsSlaSeconds, slaTime])

  const status = useMemo(() => handleSLA(conversation, () => conversation, timePausedInSla), [conversation, timePausedInSla])

  const lastTime = useRef(null)

  const time = useStateWithIntervalUpdate(
    useCallback(() => {
      if (
        conversation.usefulTimeCounter &&
        conversation.channel === 'real_automation' &&
        ['bursting', 'overdue', 'normal', 'inactive'].includes(status)
      ) {
        const now = new Date()

        const createdAt = new Date(conversation.createdAt)

        const timeInMs = now.getTime() - createdAt.getTime() - timePausedInSla - conversation.slaLate * 1000

        const timeInS = timeInMs / 1000

        if (!lastTime.current || Math.abs(timeInS - lastTime.current) > 0.9) lastTime.current = timeInS

        return lastTime.current * -1
      }

      if (conversation.status === 'closed') return null

      const now = moment();
      const msgTime = moment(conversation.firstWithoutAnswer.time);
      const delta = now.diff(msgTime, "seconds");

      return parseInt(conversation.slaLate) - delta;
    }, [conversation, timePausedInSla, status]),
    900
  )

  const removerSequenceTabs = (tabs) => {
    let tabsFilter = [];
    for (let index = 0; index < tabs.length; index++) {
      const current = tabs[index];      
      if(current && current.tabId){
        const prev = tabs[index - 1] ? tabs[index - 1] : null;
        const next = tabs[index + 1] ? tabs[index + 1] : null;
        let findIndex = -1;
        const lastIndex = tabsFilter.length > 0 ? tabsFilter.length - 1 : -1;

        if(lastIndex >= 0 && tabsFilter[lastIndex] && tabsFilter[lastIndex].tabId == current.tabId){
          findIndex = lastIndex;
        }                 
  
        if(prev && prev.tabId == current.tabId && findIndex >=0){
          const lastDate = new Date(tabsFilter[findIndex]?.date);
          const currentDate = new Date(current?.date);
          if(lastDate <= currentDate){
            tabsFilter[findIndex] = current;  
          }
        }else if(next && next.tabId == current.tabId && findIndex >= 0){ 
          const lastDate = new Date(tabsFilter[findIndex]?.date);
          const currentDate = new Date(current?.date);
          if(lastDate <= currentDate){
            tabsFilter[findIndex] = current;  
          }          
        }else{    
          tabsFilter.push(current);
        }
      }else{    
        tabsFilter.push(current);
      }     
    }
    return tabsFilter;
  }

  const tabs = useMemo(()=>{
    const tabList = props?.conversation?.conversation?.ticket?.tabs ?? [];
    return removerSequenceTabs(tabList);
  },[removerSequenceTabs, props?.conversation?.conversation?.ticket?.tabs]);

  return (
    <>
      <Card className="h-100 tickets-container">
        <PerfectScrollbar className="pt-0" id="engagementScroll">
          <div>
            <div className="col mt-3" style={{ height: "58px" }}>
              <Row className="mb-1">
                <Col xs={openTicketsContent ? "9" : "4"}>
                  <h5 className="font-size-15 mt-2 text-wrap pl-0 d-flex">
                    <svg
                      className="icons-ticket"
                      width="16"
                      height="16"
                      viewBox="0 0 16 16"
                      style={{ marginRight: "10px" }}
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M11.269 5.22404C11.2363 5.15337 11.1957 5.08604 11.1383 5.02871L7.13833 1.02871C7.08099 0.971374 7.01366 0.930707 6.94299 0.898041C6.92299 0.888707 6.90166 0.883374 6.88032 0.876041C6.82433 0.857374 6.76699 0.845374 6.70766 0.842041C6.69366 0.840707 6.68099 0.833374 6.66699 0.833374H2.00033C1.26499 0.833374 0.666992 1.43137 0.666992 2.16671V12.8334C0.666992 13.5687 1.26499 14.1667 2.00033 14.1667H10.0003C10.7357 14.1667 11.3337 13.5687 11.3337 12.8334V5.50004C11.3337 5.48604 11.3263 5.47337 11.325 5.45871C11.3217 5.39937 11.3103 5.34204 11.291 5.28604C11.2843 5.26471 11.2783 5.24404 11.269 5.22404ZM9.05766 4.83337H7.33366V3.10937L9.05766 4.83337ZM2.00033 12.8334V2.16671H6.00033V5.50004C6.00033 5.86871 6.29833 6.16671 6.66699 6.16671H10.0003L10.0017 12.8334H2.00033Z"
                        className="icons-ticket"
                      />
                      <path
                        d="M3.33301 7.50004H8.66634V8.83337H3.33301V7.50004ZM3.33301 10.1667H8.66634V11.5H3.33301V10.1667ZM3.33301 4.83337H4.66634V6.16671H3.33301V4.83337Z"
                        className="icons-ticket"
                      />
                    </svg>
                    {openTicketsContent ? t("In queue") : t("Called")}
                  </h5>
                </Col>
                <Col
                  xs={openTicketsContent ? "3" : "4"}
                  style={{ marginLeft: openTicketsContent ? 0 : -12 }}
                >
                  <div
                    className="font-size-12 text-wrap pl-0 d-flex justify-content-end"
                    role="button"
                    onClick={() => setOpenTicketsContent((prev) => !prev)}
                  >
                    {openTicketsContent ? (
                      <div
                        className={`btn nav-btn nav-btn-light-sec ${
                          mainTheme === "dark" ? "text-white" : "text-black"
                          }`}
                      >
                        <i class="bx bx-arrow-back font-size-15"></i>
                      </div>
                    ) : (
                      t("Tickets in queue") +
                      ` (${consumerTicketsData?.count ?? "-"})`
                    )}
                  </div>
                </Col>
                {!openTicketsContent && (
                  <Col xs="3" className="">
                    <ul className="list-inline user-chat-nav text-right mb-0">
                      <Clock
                        chatId={props?.conversation?.conversation}
                        endTime={props?.conversation?.conversation?.end}
                        assignedTime={
                          props?.conversation?.conversation?.assignedTime
                        }
                      />
                    </ul>
                  </Col>
                )}
                {!openTicketsContent && (
                  <Col xs="1" className="pl-0 pr-0">
                    <OtherOptionsButton
                      options={props.moreOtions}
                      onclick={props.moreOpAction}
                    />
                  </Col>
                )}
              </Row>
              {!openTicketsContent ? (
                <Row className="current-ticket-data">
                  <Col xs="12">
                    <Nav
                      tabs
                      className="nav-tabs-custom nav-justified mt-3"
                      style={{ width: "100%", textAlign: "left" }}
                    >
                      <NavItem
                        lassName="nav-tabs-ticket"
                        style={{ width: "100%", textAlign: "left" }}
                      >
                        <NavLink
                          style={{
                            cursor: "pointer",
                            padding: "0px 0px",
                            marginBottom: "10px",
                          }}
                          className={classnames({
                            active: customActiveTab === "1",
                          })}
                          onClick={() => {
                            setCustomActiveTab("1");
                          }}
                        >
                          <span className="d-none d-sm-block">
                            <svg
                              className="icons-ticket"
                              width="12"
                              height="14"
                              viewBox="0 0 12 14"
                              style={{ marginRight: "10px" }}
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                d="M5.99967 8.33333C7.47034 8.33333 8.66634 7.13733 8.66634 5.66667C8.66634 4.196 7.47034 3 5.99967 3C4.52901 3 3.33301 4.196 3.33301 5.66667C3.33301 7.13733 4.52901 8.33333 5.99967 8.33333ZM5.99967 4.33333C6.73501 4.33333 7.33301 4.93133 7.33301 5.66667C7.33301 6.402 6.73501 7 5.99967 7C5.26434 7 4.66634 6.402 4.66634 5.66667C4.66634 4.93133 5.26434 4.33333 5.99967 4.33333Z"
                                className="icons-ticket"
                              />
                              <path
                                d="M5.61372 13.5427C5.72972 13.6254 5.86505 13.6667 6.00038 13.6667C6.13572 13.6667 6.27105 13.6254 6.38705 13.5427C6.58972 13.3994 11.3531 9.96004 11.3337 5.66671C11.3337 2.72604 8.94105 0.333374 6.00038 0.333374C3.05972 0.333374 0.667051 2.72604 0.667051 5.66337C0.647718 9.96004 5.41105 13.3994 5.61372 13.5427ZM6.00038 1.66671C8.20638 1.66671 10.0004 3.46071 10.0004 5.67004C10.0144 8.62871 7.07505 11.2854 6.00038 12.1567C4.92638 11.2847 1.98638 8.62737 2.00038 5.66671C2.00038 3.46071 3.79438 1.66671 6.00038 1.66671Z"
                                className="icons-ticket"
                              />
                            </svg>
                            {t("Current data")}
                          </span>
                        </NavLink>
                      </NavItem>

                      <NavItem style={{ width: "100%", textAlign: "left" }}>
                        <NavLink
                          style={{
                            cursor: "pointer",
                            padding: "0px 0px",
                            marginBottom: "10px",
                          }}
                          className={classnames({
                            active: customActiveTab === "2",
                          })}
                          onClick={() => {
                            if(messageConsumer && !messageConsumer.chats) {
                              dispatch(getConsumerConversations(conversation?.consumer?.id, conversation.channel))
                            }
                            setCustomActiveTab("2");
                          }}
                        >
                          <span className="d-none d-sm-block">
                            <svg
                              className="icons-ticket"
                              width="14"
                              height="12"
                              viewBox="0 0 14 12"
                              style={{ marginRight: "10px" }}
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                d="M7 3.33337V6.66671H10.3333V5.33337H8.33333V3.33337H7Z"
                                className="icons-ticket"
                              />
                              <path
                                d="M13.1943 3.66466C13.0437 3.30799 12.8577 2.96466 12.6417 2.64533C12.427 2.32666 12.181 2.02799 11.909 1.75666C11.637 1.48533 11.3397 1.23999 11.021 1.02466C10.6997 0.807328 10.3563 0.621994 10.0023 0.471994C9.63901 0.318661 9.25968 0.200661 8.87568 0.121994C8.08834 -0.0400057 7.24634 -0.0406724 6.45834 0.121994C6.07234 0.200661 5.69367 0.318661 5.33167 0.471328C4.97767 0.621328 4.63501 0.806661 4.31234 1.02466C3.99434 1.23933 3.69501 1.48599 3.42367 1.75733C3.15234 2.02866 2.90567 2.32799 2.69101 2.64533C2.47367 2.96799 2.28767 3.31066 2.13834 3.66399C1.98501 4.02666 1.86701 4.40599 1.78834 4.79066C1.70767 5.18533 1.66634 5.59199 1.66634 5.99999C1.66634 6.00533 1.66701 6.01133 1.66701 6.01666H0.333008L2.33301 8.66666L4.33301 6.01666H3.00034C3.00034 6.01133 2.99967 6.00533 2.99967 5.99999C2.99967 5.68199 3.03167 5.36533 3.09434 5.05866C3.15567 4.75933 3.24701 4.46533 3.36634 4.18333C3.48234 3.90866 3.62701 3.64133 3.79634 3.39133C3.96301 3.14399 4.15501 2.91199 4.36634 2.69999C4.57767 2.48799 4.81034 2.29666 5.05701 2.12999C5.30767 1.96066 5.57501 1.81599 5.85034 1.69933C6.13101 1.57999 6.42567 1.48866 6.72567 1.42733C7.33834 1.30133 7.99501 1.30199 8.60767 1.42733C8.90567 1.48866 9.20101 1.57999 9.48301 1.69933C9.75834 1.81533 10.025 1.96066 10.275 2.12866C10.5217 2.29599 10.755 2.48799 10.9663 2.69933C11.1777 2.90999 11.369 3.14266 11.5363 3.39066C11.7043 3.63866 11.849 3.90533 11.9663 4.18333C12.085 4.46133 12.1757 4.75533 12.2383 5.05733C12.301 5.36599 12.333 5.68266 12.333 5.99999C12.333 6.31733 12.301 6.63399 12.2383 6.93999C12.1757 7.24333 12.085 7.53733 11.9663 7.81599C11.849 8.09333 11.7043 8.35933 11.5357 8.60866C11.369 8.85599 11.1777 9.08866 10.9663 9.29933C10.755 9.51066 10.5217 9.70266 10.2757 9.86933C10.025 10.038 9.75901 10.1833 9.48301 10.3C9.20101 10.4193 8.90634 10.5107 8.60767 10.572C7.99567 10.6973 7.33967 10.698 6.72567 10.572C6.42634 10.5107 6.13234 10.4193 5.85034 10.3C5.57567 10.184 5.30834 10.0393 5.05834 9.87C4.81101 9.70333 4.57901 9.51133 4.36701 9.3L3.42434 10.2427C3.69567 10.5147 3.99434 10.7607 4.31234 10.9753C4.63434 11.1927 4.97767 11.3787 5.33101 11.528C5.69367 11.6813 6.07301 11.7993 6.45767 11.878C6.85168 11.9587 7.25834 12 7.66634 12C8.07434 12 8.48167 11.9587 8.87501 11.878C9.25968 11.7993 9.63901 11.682 10.0017 11.5287C10.3563 11.3787 10.6997 11.1927 11.0223 10.9747C11.3397 10.76 11.6377 10.514 11.909 10.2427C12.1803 9.97133 12.4263 9.67266 12.641 9.35533C12.8577 9.03533 13.0437 8.69199 13.1943 8.33599C13.3463 7.97733 13.4643 7.59866 13.5443 7.20799C13.625 6.81333 13.6663 6.40666 13.6663 5.99999C13.6663 5.59333 13.625 5.18666 13.5443 4.79066C13.4643 4.40133 13.3463 4.02266 13.1943 3.66466Z"
                                className="icons-ticket"
                              />
                            </svg>
                            {t("Call history")}
                          </span>
                        </NavLink>
                      </NavItem>
                    </Nav>
                  </Col>
                  <div className="w-100">
                    <TabContent
                      activeTab={customActiveTab}
                      className="text-muted"
                    >
                      <TabPane tabId="1" className="w-100">
                        <div>
                          <div className="tab-acordeon w-100">
                            <div
                              className="d-flex extra-info-sub-item pointer mb-2 mt-3 py-0 pl-0 tab-name"
                              onClick={() => {
                                let aux = [...collapse];
                                aux[0] = !aux[0];
                                setCollapse(aux);
                              }}
                            >
                              <div className="font-weight-bold p-2">
                                {t("Process data")}
                                <span className="icon-ticket" align="left">
                                  <i
                                    className={`bx bx bxs-chevron-right color font-size-15 item ${
                                      collapse[0] ? "opened" : "closed"
                                      }`}
                                  />
                                </span>
                              </div>
                            </div>
                          </div>
                          <Collapse
                            className="mx-1 mb-3 my-0 "
                            isOpen={collapse[0]}
                          >
                            <HorizontalTimeline
                              time={time}
                              processsData={
                                props?.conversation?.conversation?.ticket
                                  ?.processData
                              }
                            ></HorizontalTimeline>
                            <VerticalTimeline
                              processsData={tabs}
                              start={
                                props?.conversation?.conversation?.ticket
                                  ?.processData?.start
                              }
                              finished={
                                props?.conversation?.conversation?.ticket
                                  ?.processData?.finished
                              }
                            ></VerticalTimeline>
                          </Collapse>
                        </div>

                        <div>
                          <div className="tab-acordeon w-100">
                            <div
                              className="d-flex extra-info-sub-item pointer mb-2 py-0 pl-0 tab-name"
                              onClick={() => {
                                let aux = [...collapse];
                                aux[2] = !aux[2];
                                setCollapse(aux);
                              }}
                            >
                              <div className="font-weight-bold p-2">
                                {t("Form Data")}

                                <span className="icon-ticket" align="left">
                                  <i
                                    className={`bx bx bxs-chevron-right color font-size-15 item ${
                                      collapse[2] ? "opened" : "closed"
                                      }`}
                                  />
                                </span>
                              </div>
                            </div>
                          </div>
                          <Collapse className="mx-1 my-0 " isOpen={collapse[2]}>
                            <FormsData
                              ticketName={
                                props?.conversation?.conversation?.ticket
                                  ?.processData?.name
                              }
                              chatId={interactionsChatId}
                              protocol={ props?.conversation?.conversation?.ticket
                                ?.processData?.protocol
                              }
                              formData={
                                props?.conversation?.conversation?.ticket
                                  ?.formData
                              }
                            ></FormsData>
                          </Collapse>
                        </div>
                      </TabPane>
                      <TabPane tabId="2">
                        {typeof historyChats === "undefined" ? (
                          loading2
                        ) : historyChats.length === 0 ? (
                          <div className="widgetSection d-flex align-items-center h-100 p-4">
                            <div className="d-flex flex-column">
                              <label
                                className="font-weight-bold font-size-16 text-center mb-5 pb-2"
                                style={{ opacity: 0.7 }}
                              >
                                {t("No history")}
                              </label>
                            </div>
                          </div>
                        ) : null}
                        {historyChats?.map((chat, index) => (
                          <div>
                            <Card className="mt-2 pointer">
                              <CardBody className="p-0 ">
                                <Col>
                                  <div class="pt-1 border">
                                    <HorizontalTimeline
                                      processsData={
                                        chat?.ticketInfo?.processData
                                      }
                                    ></HorizontalTimeline>
                                    <div className="tab-acordeon w-100">
                                      <div
                                        className="d-flex extra-info-sub-item pointer mb-2 py-0 pl-0 tab-name"
                                        onClick={() => {
                                          let aux = [...collapse];
                                          aux[(index + 1) * 4] =
                                            !aux[(index + 1) * 4];
                                          setCollapse(aux);
                                        }}
                                      >
                                        <div className="font-weight-bold p-2">
                                          {t("View all information")}
                                          <span
                                            className="icon-ticket"
                                            align="left"
                                          >
                                            <i
                                              className={`bx bx bxs-chevron-right color font-size-15 item ${
                                                collapse[(index + 1) * 4]
                                                  ? "opened"
                                                  : "closed"
                                                }`}
                                            />
                                          </span>
                                        </div>
                                      </div>
                                    </div>
                                    <Collapse
                                      className="mb-3 my-0 "
                                      isOpen={collapse[(index + 1) * 4]}
                                    >
                                      <VerticalTimeline
                                        processsData={chat?.ticketInfo?.tabs}
                                        start={
                                          chat?.ticketInfo?.processData?.start
                                        }
                                        finished={
                                          chat?.ticketInfo?.processData
                                            ?.finished
                                        }
                                      ></VerticalTimeline>

                                      <div>
                                        <div className="tab-acordeon w-100">
                                          <div
                                            className="d-flex extra-info-sub-item pointer mb-2 py-0 pl-0 tab-name"
                                            onClick={() => {
                                              let aux = [...collapse];
                                              aux[(index + 1) * 4 + 2] =
                                                !aux[(index + 1) * 4 + 2];
                                              setCollapse(aux);
                                            }}
                                          >
                                            <div className="font-weight-bold p-2">
                                              {t("Form Data")}
                                              <span
                                                className="icon-ticket"
                                                align="left"
                                              >
                                                <i
                                                  className={`bx bx bxs-chevron-right color font-size-15 item ${
                                                    collapse[
                                                      (index + 1) * 4 + 2
                                                    ]
                                                      ? "opened"
                                                      : "closed"
                                                    }`}
                                                />
                                              </span>
                                            </div>
                                          </div>
                                        </div>
                                        <Collapse
                                          className="mx-1 my-0 "
                                          isOpen={collapse[(index + 1) * 4 + 2]}
                                        >
                                          <FormsData
                                            ticketName={
                                              chat?.ticketInfo?.processData
                                                ?.name
                                            }
                                            formData={
                                              chat?.ticketInfo?.formData
                                            }
                                            index={index}
                                          ></FormsData>
                                        </Collapse>
                                      </div>
                                      <div>
                                        <div className="tab-acordeon w-100">
                                          <div
                                            className="d-flex extra-info-sub-item pointer mb- py-0 pl-0 tab-name"
                                            onClick={() => {
                                              let aux = [...collapse];
                                              aux[(index + 1) * 4 + 3] = !aux[(index + 1) * 4 + 3];
                                              setCollapse(aux);
                                            }}
                                          >
                                            <div className="font-weight-bold p-2">
                                              {t("History of Interactions")}
                                              <span className="icon-ticket" align="left">
                                                <i
                                                  className={`bx bx bxs-chevron-right color font-size-15 item ${collapse[(index + 1) * 4 + 3] ? "opened" : "closed"
                                                    }`}
                                                />
                                              </span>
                                            </div>
                                          </div>
                                        </div>
                                        <Collapse
                                          className="mx-1 mb-3 my-0 "
                                          isOpen={collapse[(index + 1) * 4 + 3]}
                                        >
                                          <Interaction chatId={chat?.conversationId} isVisible={collapse[(index + 1) * 4 + 3]}/>
                                        </Collapse>
                                      </div>
                                    </Collapse>
                                  </div>
                                </Col>
                              </CardBody>
                            </Card>
                          </div>
                        ))}
                      </TabPane>
                      <TabPane tabId="1" className="w-100">
                        <div>
                          <div className="tab-acordeon w-100">
                            <div
                              className="d-flex extra-info-sub-item pointer mb- py-0 pl-0 tab-name"
                              onClick={() => {
                                let aux = [...collapse];
                                aux[3] = !aux[3];
                                setCollapse(aux);
                              }}
                            >
                              <div className="font-weight-bold p-2">
                                {t("History of Interactions")}
                                <span className="icon-ticket" align="left">
                                  <i
                                    className={`bx bx bxs-chevron-right color font-size-15 item ${
                                      collapse[3] ? "opened" : "closed"
                                      }`}
                                  />
                                </span>
                              </div>
                            </div>
                          </div>
                          <Collapse
                            className="mx-1 mb-3 my-0 "
                            isOpen={collapse[3]}
                          >
                            <Interaction chatId={interactionsChatId} isVisible={collapse[3]}/>
                          </Collapse>
                        </div>
                      </TabPane>
                    </TabContent>
                  </div>
                </Row>
              ) : (
                <ConsumerTickets
                  consumerId={props?.conversation?.conversation?.consumer?.id}
                  chatId={props?.conversation?.conversation?.conversationId}
                  handleRefresh={handleRefresh}
                  data={consumerTicketsData}
                />
              )}
            </div>
          </div>
        </PerfectScrollbar>
      </Card>
    </>
  );
};
export default withTranslation()(React.memo(TicketChat));
